import { c as _c } from "react/compiler-runtime";
import { LeagueLogo } from '../league/LeagueLogo';
import { SF6Logo } from './SF6Logo';
import { WoWLogo } from './WoWLogo';
import { TwoKOLogo } from '../2xko/TwoKOLogo';
import { Gamepad2 } from 'lucide-react';
import { ArcRaidersLogo } from './ArcRaidersLogo';
import { Dota2Logo } from './Dota2Logo';
import { CS2Logo } from './CS2Logo';
import { GGSTLogo } from './GGSTLogo';
export const GameLogoIcon = t0 => {
  const $ = _c(26);
  const {
    gameId,
    size: t1
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  switch (gameId) {
    case "world-of-warcraft":
      {
        let t2;
        if ($[0] !== size) {
          t2 = <WoWLogo size={size} />;
          $[0] = size;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        return t2;
      }
    case "2xko":
      {
        let t2;
        if ($[2] !== size) {
          t2 = <TwoKOLogo size={size} />;
          $[2] = size;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "league-of-legends":
      {
        let t2;
        if ($[4] !== size) {
          t2 = <LeagueLogo size={size} />;
          $[4] = size;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case "street-fighter-6":
      {
        let t2;
        if ($[6] !== size) {
          t2 = <SF6Logo size={size} />;
          $[6] = size;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
    case "arc-raiders":
      {
        let t2;
        if ($[8] !== size) {
          t2 = <ArcRaidersLogo size={size} />;
          $[8] = size;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case "dota2":
      {
        let t2;
        if ($[10] !== size) {
          t2 = <Dota2Logo size={size} />;
          $[10] = size;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "cs2":
      {
        let t2;
        if ($[12] !== size) {
          t2 = <CS2Logo size={size} />;
          $[12] = size;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        return t2;
      }
    case "ggst":
      {
        let t2;
        if ($[14] !== size) {
          t2 = <GGSTLogo size={size} />;
          $[14] = size;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        return t2;
      }
    default:
      {
        const t2 = `${size}px`;
        const t3 = `${size}px`;
        const t4 = `${size}px`;
        const t5 = `${size}px`;
        let t6;
        if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
          t6 = {
            width: t2,
            height: t3,
            minWidth: t4,
            minHeight: t5
          };
          $[16] = t2;
          $[17] = t3;
          $[18] = t4;
          $[19] = t5;
          $[20] = t6;
        } else {
          t6 = $[20];
        }
        const t7 = size * 2 / 3;
        let t8;
        if ($[21] !== t7) {
          t8 = <Gamepad2 size={t7} />;
          $[21] = t7;
          $[22] = t8;
        } else {
          t8 = $[22];
        }
        let t9;
        if ($[23] !== t6 || $[24] !== t8) {
          t9 = <div style={t6} className="bg-accent-background flex items-center justify-center">{t8}</div>;
          $[23] = t6;
          $[24] = t8;
          $[25] = t9;
        } else {
          t9 = $[25];
        }
        return t9;
      }
  }
};